import {
   AddEmailModel,
   EmailResetModel,
   LedgerSignatureModel,
   LoginModel,
   MessageSignatureModel,
   PasswordResetRequestModel,
   SignupEmailModel,
   SignupInitialModel,
   SignupModel,
} from '../models';
import {
   AddEmailSchema,
   AuthTokenSchema,
   EmailResetSchema,
   EmailVerificationResponseSchema,
   EmailVerificationSchema,
   LedgerSignatureSchema,
   LoginSchema,
   MessageSignatureSchema,
   PasswordResetRequestSchema,
   SignupEmailSchema,
   SignupInitialSchema,
   SignupSchema,
   UserSchema,
} from '../schemas';
import { validateWithSchema } from '../utils';
import { axiosSecure, handleError, handleResponse, RequestResponse } from './config';

export const authenticate = async (signature: MessageSignatureModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web3/authenticate', validateWithSchema(MessageSignatureSchema, signature))
      .then((response) => handleResponse(response, UserSchema))
      .catch(handleError);
};

export const authenticateLedger = async (signature: LedgerSignatureModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web3/authenticate-ledger', validateWithSchema(LedgerSignatureSchema, signature))
      .then((response) => handleResponse(response, UserSchema))
      .catch(handleError);
};

export const getUserAuthToken = async (): Promise<RequestResponse> => {
   return await axiosSecure
      .get('/auth/web3/auth-token')
      .then((response) => handleResponse(response, AuthTokenSchema))
      .catch(handleError);
};

export const logout = async (): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/logout')
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const signup = async (signup: SignupModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/signup', validateWithSchema(SignupSchema, signup))
      .then((response) => handleResponse(response, UserSchema))
      .catch(handleError);
};

export const signupEmail = async (signup: SignupEmailModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/signup', validateWithSchema(SignupEmailSchema, signup))
      .then((response) => handleResponse(response, UserSchema))
      .catch(handleError);
};

export const signupCheck = async (signup: SignupInitialModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/signup-check-info', validateWithSchema(SignupInitialSchema, signup))
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const signupEmailCheck = async (signup: SignupEmailModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/signup-check-info', validateWithSchema(SignupSchema, signup))
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const addEmailCheck = async (signup: AddEmailModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/signup-check-info', validateWithSchema(AddEmailSchema, signup))
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const requestEmailVerification = async (email: string): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/emails/request-verification', validateWithSchema(EmailVerificationSchema, { email }))
      .then((response) => handleResponse(response, EmailVerificationResponseSchema))
      .catch(handleError);
};

export const login = async (login: LoginModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/authenticate', validateWithSchema(LoginSchema, login))
      .then((response) => handleResponse(response, UserSchema))
      .catch(handleError);
};

export const linkWeb3Wallet = async (signature: MessageSignatureModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/link-wallet', validateWithSchema(MessageSignatureSchema, signature))
      .then((response) => handleResponse(response, UserSchema))
      .catch(handleError);
};

export const linkWeb3LedgerWallet = async (signature: LedgerSignatureModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/link-wallet-ledger', validateWithSchema(LedgerSignatureSchema, signature))
      .then((response) => handleResponse(response, UserSchema))
      .catch(handleError);
};

export const resetPasswordRequestLink = async (email: string): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/password/request-reset', validateWithSchema(EmailVerificationSchema, { email }))
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const resetPassword = async (passwordReset: PasswordResetRequestModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/password/reset', validateWithSchema(PasswordResetRequestSchema, passwordReset))
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const resetEmail = async (emailReset: EmailResetModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/email/reset', validateWithSchema(EmailResetSchema, emailReset))
      .then((response) => handleResponse(response, UserSchema))
      .catch(handleError);
};

export const resetEmailCheck = async (emailReset: EmailResetModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/email/reset-check-info', validateWithSchema(EmailResetSchema, emailReset))
      .then((response) => handleResponse(response))
      .catch(handleError);
};
